import Page from "./page";

export default function HomePage() {
    return <Page/>
}
